"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncThrottle = asyncThrottle;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _delay = _interopRequireDefault(require("../../internal/delay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

async function* asyncThrottle(source, intervalMs) {
  let waitSince = 0;

  for await (const item of source) {
    const duration = intervalMs - (Date.now() - waitSince);
    await (duration > 0 && (0, _delay.default)(duration));
    waitSince = Date.now();
    yield item;
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncThrottle, {
  validateArgs([intervalMs]) {
    if (typeof intervalMs !== 'number' || intervalMs <= 0) {
      throw new Error('The first argument (intervalMs) should be a number greater than 0');
    }
  }

});

exports.default = _default;